export const NO_VALUE = 'N/A';
export const API_ERROR_MESSAGE = 'ERROR: Cannot refresh Data source';
export const NO_USERNAME_PLACEHOLDER = 'User';
export const NO_PROPERTY_NAME = 'Unnamed property';
export const NO_SKIN_NAME = 'Unnamed skin';
export const BEST_SELLER_LIST = 'Best Sellers';
export const RELATED_PRODUCTS = 'Related Products';
export const PRODUCT_LISTING = 'Product Listing';
export const SEARCH_PRODUCT = 'Search List';
